export default "__VITE_ASSET__CTH7ioSV__"